import {
  ERROR,
  OPTIMISTIC_SWITCH_ACTIVATE_AD,
  OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_FAILURE_BODY,
  OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT,
} from "../i18n/keysTranslations";
import { getObjectError } from "../utils/string";
import { OPTIMISTIC_SWITCH_ACTION, OPTIMISTIC_SWITCH_KIND } from "./kinds";

const getActionKey = ({ kind, activate }) => {
  switch (kind) {
    case OPTIMISTIC_SWITCH_KIND.CAMPAIGN:
      return activate
        ? OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN
        : OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN;
    case OPTIMISTIC_SWITCH_KIND.ASSETS_GROUP:
      return activate
        ? OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP
        : OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP;
    case OPTIMISTIC_SWITCH_KIND.AD_GROUP:
      return activate
        ? OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP
        : OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP;
    case OPTIMISTIC_SWITCH_KIND.AD:
      return activate
        ? OPTIMISTIC_SWITCH_ACTIVATE_AD
        : OPTIMISTIC_SWITCH_DEACTIVATE_AD;
    case OPTIMISTIC_SWITCH_KIND.AUTOMATION:
      return activate
        ? OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION
        : OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION;
    case OPTIMISTIC_SWITCH_KIND.PROMO_CODE:
      return activate
        ? OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE
        : OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE;
    default: {
      const _exhaustive = kind;
      void _exhaustive;
      return activate
        ? OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN
        : OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN;
    }
  }
};

export const getOptimisticSwitchErrorMessage = (error) => {
  const formatted = getObjectError(error);
  return (
    formatted?.message ||
    error?.message ||
    error?.response?.data?.message ||
    String(error || "")
  );
};

export const buildOptimisticSwitchCopy = ({ t, kind, name, activate }) => {
  const actionKey = getActionKey({ kind, activate });
  const actionLabel = t(actionKey);
  const entityName = String(name || "").trim();
  const title = t(ERROR);
  const intro = t(OPTIMISTIC_SWITCH_FAILURE_BODY, {
    action: actionLabel,
    name: entityName,
  }).trim();
  const emailSubject = t(OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT);

  return {
    title,
    intro,
    emailSubject,
    actionLabel,
    kind,
    action: activate
      ? OPTIMISTIC_SWITCH_ACTION.ACTIVATE
      : OPTIMISTIC_SWITCH_ACTION.DEACTIVATE,
    name: entityName,
  };
};
